import React from 'react';
// import PropTypes from 'prop-types';
// import cx from 'classnames';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './SoldMessage.css';

class SoldMessage extends React.Component {
  render() {
    return (
      <div className={s.root}>
        <div>
          <div className={s.title}>
            <FormattedMessage id="Этот автомобиль возможно уже продан" />
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(SoldMessage);



// WEBPACK FOOTER //
// ./src/shared/components/SoldMessage/SoldMessage.js